<template>
    <div class="swiper-container-pagination" :id="id" :class="{nograb:!moreThanOne, center:center}">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <slot></slot>
            </div>
            <div class="swiper-scrollbar"></div>
        </div>
        <div class="swiper-button-prev-taaf"><span class="icon-arrow-right"></span></div>
        <div class="swiper-button-next-taaf"><span class="icon-arrow-right"></span></div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Swiper from "swiper"

    export default {
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                pageSwiperInstance: null,
                moreThanOne: true,
                count: null
            };
        },
        computed: {
            breakpointUpLg() {
                return this.$root.breakpointUpLg;
            },
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
            breakpointDownSm() {
                return this.$root.breakpointDownSm;
            },
            center() {

                if (this.count >= 3) {
                    return false
                } else if (this.count === 1) {
                    return true
                } else if (this.count === 2 && this.breakpointUpLg) {
                    return true
                } else if (this.count === 2 && this.breakpointDownSm) {
                    return false
                } else if (this.count === 2 && this.breakpointDownMd) {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            initSwiper() {


                let loop = true

                this.count = $("#" + this.id + " .swiper-slide").length

                if (this.count <= 3) {
                    loop = false
                    this.moreThanOne = false
                }

                this.pageSwiperInstance = new Swiper("#" + this.id + " .swiper-container", {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    navigation: {
                        nextEl: "#" + this.id + " .swiper-button-next-taaf",
                        prevEl: "#" + this.id + " .swiper-button-prev-taaf",
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    watchOverflow: true,
                    autoHeight: true,
                    scrollbar: {
                        el: ".swiper-scrollbar",
                        hide: true,
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                        },
                        576: {
                            slidesPerView: "auto",
                            spaceBetween: 15,
                        },
                    },

                });


            },
        },
        mounted() {
            this.initSwiper()
        },
        destroyed() {
        }
    };
</script>
